<template>
  <div>
    <TheTopProgressBar :ratio="1"/>
    <TheHeader
      :back-route="computedBackRoute"
      with-menu
    />
    <BaseSection v-if="opportunity">
      <BaseTitleGroup
        :title="$t('Management report')"
        :subtitle="opportunity.data.attributes.name"
        class="mb-8"
      />
      <template v-if="opportunity.data.attributes.managementReportDocumentId">
        <BaseParagraph class="mb-8">
          {{ $t('Management report hint') }}
        </BaseParagraph>
        <iframe
          v-if="opportunity.data.attributes.managementReportDocumentId"
          :src="`https://drive.google.com/file/d/${opportunity.data.attributes.managementReportDocumentId}/preview`"
          class="w-full h-64 mb-8"
        />
      </template>
      <BaseParagraph v-else>
        {{ $('No Management report hint') }}
      </BaseParagraph>
      <template v-if="!currentUserWish">
        <div class="pin-b pin-l fixed w-screen flex flex-row bg-white">
          <BaseButton
            :title="$t('I decline')"
            to="wish/decline"
            theme="outlined"
            class="flex-1"
            not-rounded
            @click="trackDecline"
          />
          <BaseButton
            :title="$t('Co-invest')"
            :theme="opportunity.data.attributes.wishesDisabled ? 'disabled' : 'primary'"
            to="wish/new"
            not-rounded
            class="flex-1"
          />
        </div>
      </template>
    </BaseSection>
  </div>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import customBackRoute from '../mixins/customBackRoute';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import TheTopProgressBar from '../components/TheTopProgressBar.vue';
import BaseButton from '../components/BaseButton.vue';
import { CLICKED_DECLINED_BUTTON } from '../analytics';

export default {
  name: 'ManagementReport',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    TheTopProgressBar,
    BaseButton,
  },
  mixins: [loadOpportunity, customBackRoute],
  data() {
    return {
      backRoute: 'kerala-analysis',
    };
  },
  methods: {
    trackDecline() {
      analytics.track(CLICKED_DECLINED_BUTTON);
    },
  },
};
</script>
